export default __webpack_public_path__ + "static/media/IMG_4485.0fab08cd.JPG";